import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CardLoaderSize, InfoCardData } from "../card-types";

@Component({
  selector: "info-card",
  templateUrl: "./info-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class InfoCardComponent {
  @Input() card: InfoCardData;
  @Input() loading: boolean = false;
  @Input() showSubtitle: boolean = true;
  @Input() extraClass: string = "";
  @Input() isReport: boolean = false;
  @Input() trendBesideValue: boolean = false;
  @Input() comingSoon: boolean = false;
  @Input() showExport: boolean = false;
  @Output() exportClick = new EventEmitter<void>();
  cardLoaderSize = CardLoaderSize;

  get subtitleLoading(): boolean {
    return !this.isReport && this.card.subtitleLoading === true;
  }

  get isLoading(): boolean {
    return this.loading || this.subtitleLoading;
  }

  // A card with no subtitle would print an empty footer
  get showFooter(): boolean {
    let show = true;
    if (this.isReport) {
      show = this.showSubtitle && !!this.card.subtitle;
    }
    return show;
  }

  get hasTrend(): boolean {
    let has = false;
    if (!this.isReport && this.card.percentage !== null && this.card.percentage !== undefined) {
      has = true;
    }
    return has;
  }

  get showHeaderTrend(): boolean {
    return this.hasTrend && !this.isLoading && !this.card.icon && !this.trendBesideValue;
  }

  get showValueTrend(): boolean {
    return this.hasTrend && this.trendBesideValue;
  }

  get showSubtitleTrend(): boolean {
    return this.hasTrend && !this.trendBesideValue && !!this.card.icon;
  }
}
